<div class="public-layout bg-black" [@routeAnimations]="prepareRoute(outlet)">
  <ngx-spinner name="app-spinner" type="ball-scale-multiple" size="medium" bdColor="rgba(255,255,255,1)" color="rgba(0,0,0,1)"></ngx-spinner>
  <router-outlet #outlet="outlet"></router-outlet>
</div>
